import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import '../../design-system';
import './DeveloperLayout.css';

const NAV = [
  { to: '/developers', label: 'Overview', end: true },
  { to: '/developers/docs', label: 'API reference' },
  { to: '/developers/keys', label: 'API keys' },
  { to: '/developers/webhooks', label: 'Webhooks' }
];

export const DeveloperLayout: React.FC = () => {
  return (
    <div className="dev-portal" data-theme="dark">
      <aside className="dev-portal__aside">
        <div className="dev-portal__brand">BSO Developers</div>
        <nav className="dev-portal__nav" aria-label="Developer portal">
          {NAV.map(({ to, label, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `dev-portal__nav-link${isActive ? ' dev-portal__nav-link--active' : ''}`
              }
            >
              {label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <main className="dev-portal__main">
        <Outlet />
      </main>
    </div>
  );
};
